import { Button, NavbarLogo } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuccessPage = _ref => {
  let {
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "SuccessPage",
    "data-sentry-component": "SuccessPage",
    "data-sentry-source-file": "SuccessPage.tsx",
    children: [/*#__PURE__*/_jsx(NavbarLogo, {
      className: "SuccessPage__logo",
      title: "Move",
      "data-sentry-element": "NavbarLogo",
      "data-sentry-source-file": "SuccessPage.tsx",
      "data-sentry-element": "NavbarLogo"
    }), /*#__PURE__*/_jsx("div", {
      className: "SuccessPage__header",
      children: "Thank you!"
    }), /*#__PURE__*/_jsxs("div", {
      className: "SuccessPage__desc",
      children: ["Your request has been submitted. ", /*#__PURE__*/_jsx("br", {}), " We will get back to you as soon as we can."]
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onConfirm,
      variant: "primary",
      "data-sentry-element": "Button",
      "data-sentry-source-file": "SuccessPage.tsx",
      "data-sentry-element": "Button",
      children: "OK"
    })]
  });
};
export default SuccessPage;